import { Button } from "@nabble/ui";

interface UnsavedChangesBarProps {
  count: number;
  saving: boolean;
  /** Some value is invalid, so saving isn't possible yet. */
  blocked: boolean;
  onDiscard: () => void;
}

/** How many changes are pending, with Discard and the form's submit button. */
export function UnsavedChangesBar({ count, saving, blocked, onDiscard }: UnsavedChangesBarProps): React.JSX.Element {
  return (
    <div className="nb-savebar" role="region" aria-label="Unsaved changes">
      <span>{count === 1 ? "You have 1 unsaved change" : `You have ${count} unsaved changes`}</span>
      <div className="nb-row">
        <Button label="Discard" variant="ghost" onClick={onDiscard} />
        <Button type="submit" label="Save changes" loading={saving} disabled={blocked} />
      </div>
    </div>
  );
}
